import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UpdateChannelModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/update-channel.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUpdateChargePointChannelContext } from '../../charge-point.context';
import { ChargePointChannelUpdateFormStep1Controller } from '../charge-point-channel-update-form-step-1/charge-point-channel-update-form-step-1.controller';

export interface ChargePointChannelUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<UpdateChannelModel, 'chargePointId' | 'channelId' | 'channel'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<UpdateChannelModel, 'chargePointId' | 'channelId' | 'channel'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointChannelUpdateFormController = (
  props: ChargePointChannelUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useUpdateChargePointChannelContext();

  return (
    <MultiStepFormProvider<
      Pick<UpdateChannelModel, 'chargePointId' | 'channelId' | 'channel'>
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['channel.qrCode'],
          component: <ChargePointChannelUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
